import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
// @mui
import { Box, Divider, Typography, Stack, MenuItem, IconButton, Popover } from '@mui/material';
import { commonLogoutFunc } from '../../../utils/share';
import capitalizeWords from '../../../utils/capitalize';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Profile',
    path: '/profile',
    icon: 'eva:person-fill',
  },
  {
    label: 'Settings',
    path: '/account',
    icon: 'eva:settings-2-fill',
  },
  {
    label: 'Change Password',
    path: '/auth/changepassword',
    icon: 'eva:settings-2-fill',
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const accountData = useSelector((state) => state?.login?.user || null);
  const accountUserName = useSelector((state) => state?.account || null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(null);
  const [userName, setUserName] = useState(accountUserName?.data?.userName);

  useEffect(() => {
    const user = accountUserName?.data?.userName || accountData?.userName;
    setUserName(user);
  }, [accountUserName]);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleMailClick = () => {
    navigator.clipboard.writeText(accountData?.email);
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          borderRadius: '8px',
          // p: 0,
          ...(open && {
            '&:before': {
              // zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              //  borderRadius: '100%',
              position: 'absolute',
              // bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Typography variant="subtitle2" noWrap>
          Hello, {userName ? capitalizeWords(userName || accountData?.userName) : ''}
        </Typography>
        {/* <Avatar src={account.photoURL} alt="photoURL" /> */}
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {accountData?.userName}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap onClick={handleMailClick}>
            {accountData?.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem
              key={option.label}
              onClick={() => {
                handleClose();
                navigate(option.path ?? '/');
              }}
            >
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem
          onClick={() => {
            commonLogoutFunc();
            navigate('/auth/login');
          }}
          sx={{ m: 1 }}
        >
          Logout
        </MenuItem>
      </Popover>
    </>
  );
}
